const consentStatuses = {
  active: "ACTIVE",
  inactive: "INACTIVE",
  draft: "DRAFT"
};

export default consentStatuses;
